(function () {
  var selectors = {
    menuToggle: '[data-menu-toggle]',
    menuDrawer: '[data-menu-drawer]',
    cartDrawer: '[data-cart-drawer]',
    cartOpen: '[data-cart-open]',
    cartClose: '[data-cart-close]',
    searchToggle: '[data-search-toggle]',
    searchOverlay: '[data-search-overlay]',
    searchClose: '[data-search-close]',
    searchInput: '[data-search-input]',
    quantity: '[data-quantity]',
    quantityInput: '[data-quantity-input]',
    productForm: '[data-product-form]'
  };

  function trapFocus(container) {
    var focusable = container.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    focusable[0].focus();
  }

  function toggleAttribute(element, attribute, force) {
    if (!element) return;
    var active = typeof force === 'boolean' ? force : element.getAttribute(attribute) !== 'true';
    element.setAttribute(attribute, active ? 'true' : 'false');
    return active;
  }

  function closeMenuDrawer() {
    var drawer = document.querySelector(selectors.menuDrawer);
    var toggles = document.querySelectorAll(selectors.menuToggle);
    if (drawer) drawer.setAttribute('aria-expanded', 'false');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.classList.remove('menu-open');
  }

  function openSearch(toggle) {
    var overlay = document.querySelector(selectors.searchOverlay);
    var input = overlay ? overlay.querySelector(selectors.searchInput) : null;
    if (!overlay) return;
    closeMenuDrawer();
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('search-open');
    document.querySelectorAll(selectors.searchToggle).forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () {
      if (input) input.focus();
    }, 40);
  }

  function closeSearch() {
    var overlay = document.querySelector(selectors.searchOverlay);
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('search-open');
    document.querySelectorAll(selectors.searchToggle).forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var searchToggle = event.target.closest(selectors.searchToggle);
    if (searchToggle) {
      event.preventDefault();
      openSearch(searchToggle);
      return;
    }

    var searchClose = event.target.closest(selectors.searchClose);
    if (searchClose) {
      event.preventDefault();
      closeSearch();
      return;
    }

    var toggle = event.target.closest(selectors.menuToggle);
    if (toggle) {
      var drawer = document.querySelector(selectors.menuDrawer);
      var open = toggleAttribute(drawer, 'aria-expanded');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('menu-open', open);
      if (open) trapFocus(drawer);
    }

    var cartOpen = event.target.closest(selectors.cartOpen);
    if (cartOpen) {
      var drawerOpen = document.querySelector(selectors.cartDrawer);
      if (drawerOpen) {
        event.preventDefault();
        drawerOpen.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('cart-open');
        trapFocus(drawerOpen);
      }
    }

    var cartClose = event.target.closest(selectors.cartClose);
    if (cartClose) {
      var drawerClose = document.querySelector(selectors.cartDrawer);
      if (drawerClose) {
        drawerClose.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('cart-open');
      }
    }

    var quantityButton = event.target.closest('[data-quantity-action]');
    if (quantityButton) {
      var wrapper = quantityButton.closest(selectors.quantity);
      var input = wrapper ? wrapper.querySelector(selectors.quantityInput) : null;
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      var next = quantityButton.dataset.quantityAction === 'increase' ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var menuDrawer = document.querySelector(selectors.menuDrawer);
    var cartDrawer = document.querySelector(selectors.cartDrawer);
    if (menuDrawer) menuDrawer.setAttribute('aria-expanded', 'false');
    if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');
    closeSearch();
    document.documentElement.classList.remove('menu-open', 'cart-open');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest(selectors.productForm);
    if (!form || form.dataset.ajaxCart !== 'drawer' || !window.fetch || !window.SnorlaxTheme) return;
    event.preventDefault();

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.classList.add('is-loading');

    fetch(window.SnorlaxTheme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function () {
        return fetch(window.SnorlaxTheme.routes.cart + '.js');
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
        var drawer = document.querySelector(selectors.cartDrawer);
        if (drawer) {
          drawer.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('cart-open');
        } else {
          window.location.href = window.SnorlaxTheme.routes.cart;
        }
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submit) submit.classList.remove('is-loading');
      });
  });
})();
